import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ShortcutMenu } from '@/plugins/shortcut-menu/shortcut-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { LayerHotkeyType } from '../../../../type';
import { layerCloneShortcutItem } from './layer-clone-item';
import { layerDeleteShortcutItem } from './layer-delete-item';

const LayerShortcutMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);
        framework.service.registration.getInstance<ShortcutMenu>('ShortcutMenu').addItems([
            {
                key: LayerHotkeyType.CLONE,
                sort: 80,
                render: layerCloneShortcutItem,
            },
            {
                key: LayerHotkeyType.DELETE,
                sort: 110,
                render: layerDeleteShortcutItem,
            },
        ]);
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'layer-shortcut-menu',
    render() {
        return <LayerShortcutMenuView />;
    },
};

export default exportPlugin;
